module.exports = __webpack_public_path__ + "static/avatar-820e42e366e9b9b206c9d41229821cde.jpg";